import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { resolveMirror } from '../../services/mirrorApi';

const MobileWelcome = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const mirrorId = searchParams.get('mirrorId') || localStorage.getItem('mirrorId');
  const salonId = searchParams.get('salonId') || localStorage.getItem('salonId');
  const qrToken = searchParams.get('qrToken') || localStorage.getItem('qrToken');
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    // Persist QR params
    if (mirrorId) localStorage.setItem('mirrorCode', mirrorId);
    if (salonId) localStorage.setItem('salonId', salonId);
    if (qrToken) localStorage.setItem('qrToken', qrToken);

    // Resolve mirror code -> Mongo IDs + salon, so booking flow can use it
    const run = async () => {
      setIsRedirecting(true);
      try {
        if (mirrorId) {
          const res = await resolveMirror(mirrorId);
          const mirror = res.data?.mirror;
          if (mirror?.mirrorId) localStorage.setItem('mirrorId', mirror.mirrorId);
          if (mirror?.mirrorCode) localStorage.setItem('mirrorCode', mirror.mirrorCode);
          if (mirror?._id) localStorage.setItem('mirrorObjectId', mirror._id);
          if (mirror?.salon?._id) localStorage.setItem('salonId', mirror.salon._id);
        }
      } catch (e) {
        // If resolve fails, we still allow navigation; booking will fail with a clear error later
        // eslint-disable-next-line no-console
        console.error('Failed to resolve mirror:', e);
      } finally {
        const params = new URLSearchParams();
        if (mirrorId) params.set('mirrorId', mirrorId);
        if (qrToken) params.set('qrToken', qrToken);
        navigate(`/mobile-login${params.toString() ? `?${params.toString()}` : ''}`, { replace: true });
      }
    };
    run();
  }, [mirrorId, salonId, qrToken, navigate]);

  return isRedirecting ? <div style={{ padding: '24px', textAlign: 'center' }}>Redirecting...</div> : null;
};

export default MobileWelcome;
